
import React from 'react';
import { Typography, Box } from '@mui/material';

const HomePage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        한자 8급 학습
      </Typography>
      <Typography variant="h5">
        연습하고 싶은 메뉴를 선택하세요.
      </Typography>
    </Box>
  );
};

export default HomePage;
